import script from "./PayrollDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollDashboard.vue?vue&type=script&setup=true&lang=js"

import "./PayrollDashboard.vue?vue&type=style&index=0&id=546075a8&scoped=true&lang=css"

import exportComponent from "/Users/thabangteddy/Downloads/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-546075a8"]])

export default __exports__